import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { useApp } from '../context/AppContext';

const fmt = (n) => `₹${Number(n || 0).toFixed(2)}`;
const today = () => new Date().toISOString().split('T')[0];

export default function Orders() {
  const { toast } = useApp();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateFrom, setDateFrom] = useState(today());
  const [dateTo, setDateTo] = useState(today());
  const [detail, setDetail] = useState(null);

  const load = () => {
    setLoading(true);
    api.getOrders({ date_from: dateFrom, date_to: dateTo }).then(d => {
      setOrders(d);
      setLoading(false);
    });
  };

  useEffect(() => { load(); }, [dateFrom, dateTo]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this order?')) return;
    await api.deleteOrder(id);
    toast('Order deleted');
    load();
  };

  const openDetail = async (id) => {
    const o = await api.getOrder(id);
    setDetail(o);
  };

  const totalAmount = orders.reduce((s, o) => s + o.total_amount, 0);

  return (
    <div className="page-body">
      <div className="search-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div>
            <label style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>From</label>
            <input type="date" value={dateFrom} max={today()} onChange={e => setDateFrom(e.target.value)} style={{ width: 'auto' }} />
          </div>
          <div>
            <label style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>To</label>
            <input type="date" value={dateTo} max={today()} onChange={e => setDateTo(e.target.value)} style={{ width: 'auto' }} />
          </div>
        </div>
        <div style={{ marginLeft: 'auto', background: 'var(--iocl-panel)', border: '1px solid var(--iocl-border)', borderRadius: 6, padding: '8px 16px', textAlign: 'right' }}>
          <div style={{ fontSize: 11, color: 'var(--iocl-muted)' }}>{orders.length} orders</div>
          <div style={{ fontFamily: 'Rajdhani', fontSize: 22, fontWeight: 700, color: 'var(--iocl-orange)' }}>{fmt(totalAmount)}</div>
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Employee</th>
                <th>Department</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6}><div className="loading-center"><span className="spinner" /></div></td></tr>
              ) : orders.length === 0 ? (
                <tr><td colSpan={6}><div className="empty-state"><p>No orders in this date range</p></div></td></tr>
              ) : orders.map(o => (
                <tr key={o.id}>
                  <td style={{ color: 'var(--iocl-muted)', fontSize: 12 }}>#{o.id}</td>
                  <td style={{ color: 'var(--iocl-white)', fontWeight: 500 }}>{o.employee_name}</td>
                  <td><span className="badge badge-blue">{o.department_name}</span></td>
                  <td style={{ color: 'var(--iocl-muted)' }}>{o.order_date}</td>
                  <td className="text-orange" style={{ fontWeight: 600 }}>{fmt(o.total_amount)}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => openDetail(o.id)}>View</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(o.id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {detail && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setDetail(null)}>
          <div className="modal modal-lg">
            <div className="modal-header">
              <div>
                <h3 className="modal-title">Order #{detail.id}</h3>
                <div style={{ fontSize: 12, color: 'var(--iocl-muted)', marginTop: 2 }}>{detail.employee_name} · {detail.order_date}</div>
              </div>
              <button className="btn btn-secondary btn-sm btn-icon" onClick={() => setDetail(null)}>✕</button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Category</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {detail.items?.map(item => (
                  <tr key={item.id}>
                    <td style={{ color: 'var(--iocl-white)' }}>{item.item_name}</td>
                    <td><span className="badge badge-blue">{item.category}</span></td>
                    <td>{item.quantity}</td>
                    <td style={{ color: 'var(--iocl-muted)' }}>₹{item.unit_price}</td>
                    <td className="text-orange">₹{item.subtotal}</td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan={4} style={{ textAlign: 'right' }}>TOTAL</td>
                  <td>₹{detail.total_amount}</td>
                </tr>
              </tbody>
            </table>
            {detail.remarks && (
              <div style={{ marginTop: 12, padding: '10px 14px', background: 'var(--iocl-panel)', borderRadius: 6, fontSize: 13, color: 'var(--iocl-light)' }}>
                📝 {detail.remarks}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
